import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Small "i" affordance that explains how a number on the ABD pages is
 * computed. Rendered inline next to a KPI label, pill, or chart heading.
 *
 * Every ABD count is one of two very different things — a SHIPMENT count
 * (one row per AWB) or a MISSED-APPOINTMENT count (one per history entry,
 * an AWB missed 3 times counts 3) — and several are further scoped to
 * still-pending shipments only. Ops compared those numbers across pages
 * and read them as a mismatch; this tooltip is how the page says which
 * definition the number uses.
 */
export default function InfoTip({ title, size = 14, sx }) {
    if (!title) return null;
    return (
        <Tooltip title={title} arrow placement='top' enterTouchDelay={0}>
            <IconButton
                size='small'
                aria-label='info'
                onClick={(e) => e.stopPropagation()}
                sx={{ p: '2px', ml: '4px', color: '#9e9e9e', '&:hover': { color: '#1565c0' }, ...sx }}
            >
                <InfoOutlinedIcon sx={{ fontSize: size }} />
            </IconButton>
        </Tooltip>
    );
}
